var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDisplayDark = function SvgDisplayDark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.3724 24 0 18.6276 0 12C0 5.3724 5.3724 0 12 0C18.6276 0 24 5.3724 24 12C24 18.6276 18.6276 24 12 24ZM3.9948 17.31C4.78354 18.4901 5.82416 19.4806 7.04172 20.2102C8.25928 20.9398 9.62348 21.3904 11.0361 21.5294C12.4487 21.6684 13.8745 21.4924 15.211 21.0141C16.5474 20.5358 17.7611 19.7672 18.7648 18.7634C19.7684 17.7597 20.537 16.5459 21.0151 15.2094C21.4933 13.873 21.6691 12.4471 21.53 11.0345C21.3909 9.62192 20.9402 8.25776 20.2105 7.04026C19.4808 5.82277 18.4902 4.78224 17.31 3.9936C17.8274 5.83947 17.844 7.78982 17.3581 9.64424C16.8722 11.4987 15.9013 13.1903 14.5452 14.5452C13.1904 15.9011 11.499 16.8719 9.64479 17.3578C7.79061 17.8437 5.8405 17.8272 3.9948 17.31Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisplayDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/displayDark.ee014b13.svg";
export { ForwardRef as ReactComponent };